// extracted by mini-css-extract-plugin
module.exports = {"container":"_e606221","item":"_d8a46ed","singleDetails":"_0790d41","starSubIcon":"_e90e359","selection":"_416d794"};